export default __webpack_public_path__ + "static/register-bg-55f24019397b250ae34e4ef61e741022.png";